import { useState } from 'react';

const useDeviceDetection = () => {
    const [device, setDeviceDetection] = useState(() => {
        if (typeof navigator === 'undefined') return 'Desktop';

        const nUserAgent = navigator.userAgent.toLowerCase();
        if (
            nUserAgent.indexOf('mobile') > -1 ||
            nUserAgent.indexOf('android') > -1 ||
            nUserAgent.indexOf('iphone') > -1 ||
            nUserAgent.indexOf('ipad') > -1 ||
            nUserAgent.indexOf('macintosh') > -1
        ) {
            return 'Mobile';
        }
        return 'Desktop';
    });

    return device;
}

export default useDeviceDetection;
